import { isSystemAdmin } from '@/constants/capabilities';
import type { AuthUser } from '@/types/auth';
import type { ProjectReportRecord, ProjectReportStatus } from '@/types/project-report';

export function canCreateProjectReport(
  user: AuthUser | null,
  projectManagerId: string | undefined,
): boolean {
  if (!user || !projectManagerId) {
    return false;
  }
  return isSystemAdmin(user) || user.id === projectManagerId;
}

export function canCommentProjectReport(
  user: AuthUser | null,
  report: Pick<ProjectReportRecord, 'status' | 'createdBy'> | null,
): boolean {
  if (!user || !report) {
    return false;
  }
  if (report.status === 'DRAFT') {
    return false;
  }
  if (report.createdBy.id === user.id) {
    return false;
  }
  return isSystemAdmin(user) || user.canManageTeam || user.role === 'LEADER';
}

export function canDeleteProjectReport(
  user: AuthUser | null,
  report: Pick<ProjectReportRecord, 'createdBy'> & {
    project: { projectManager: { id: string } };
  } | null,
): boolean {
  if (!user || !report) {
    return false;
  }
  if (isSystemAdmin(user)) {
    return true;
  }
  if (report.createdBy.id === user.id) {
    return true;
  }
  return report.project.projectManager.id === user.id;
}

export function isProjectReportSubmitted(status: ProjectReportStatus): boolean {
  return status === 'SUBMITTED' || status === 'COMMENTED';
}
